
import { 
  Building, 
  Home, 
  MapPin, 
  Key, 
  TrendingUp, 
  Calculator,
  FileText,
  Users
} from 'lucide-react';
import type { Product } from './types';

export const realEstateProducts: Product[] = [
  {
    id: 'property-management-system',
    title: 'Property Management System',
    subtitle: 'Complete property portfolio management',
    description: 'Comprehensive property management with tenant management, maintenance tracking, rent collection, and financial reporting for UK landlords and property managers.',
    icon: Building,
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Real Estate & Property',
    status: 'Available',
    businessTypes: ['#property-management', '#real-estate', '#landlords', '#property-investment', '#residential'],
    features: [
      'Tenant Management & Right to Rent Checks',
      'Rent Collection & Payment Processing',
      'Maintenance Request Management',
      'Assured Shorthold Tenancy Management',
      'Financial Reporting & Tax Analytics',
      'Property Inspection Scheduling',
      'Vendor Management & Coordination',
      'Automated Late Payment Notices',
      'Deposit Protection Scheme Integration',
      'Council Tax & Utility Management'
    ],
    pricing: { setup: 42000, monthly: 1932 },
    color: 'from-blue-500 to-indigo-600'
  },
  {
    id: 'real-estate-crm',
    title: 'Real Estate CRM',
    subtitle: 'Agent and client management platform',
    description: 'Specialized CRM for real estate professionals with lead management, property matching, and transaction tracking.',
    icon: Users,
    image: 'https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Real Estate & Property',
    status: 'Available',
    businessTypes: ['#real-estate-agents', '#brokers', '#property-sales', '#real-estate-agencies', '#property-marketing'],
    features: [
      'Lead Generation & Management',
      'Property Listing Management',
      'Client Matching & Recommendations',
      'Transaction Pipeline Tracking',
      'Commission Calculation & Reporting',
      'Marketing Campaign Management',
      'Document Management & E-signatures',
      'Mobile App for Field Work'
    ],
    pricing: { setup: 38000, monthly: 1748 },
    color: 'from-green-500 to-teal-600'
  },
  {
    id: 'property-valuation-platform',
    title: 'Property Valuation Platform',
    subtitle: 'AI-powered property assessment',
    description: 'Advanced property valuation with market analysis, comparable sales data, and AI-powered pricing recommendations.',
    icon: Calculator,
    image: 'https://images.unsplash.com/photo-1460472178825-e5240623afd5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Real Estate & Property',
    status: 'Available',
    businessTypes: ['#property-valuation', '#appraisers', '#real-estate-investment', '#property-analytics', '#market-analysis'],
    features: [
      'Automated Valuation Models (AVM)',
      'Comparable Sales Analysis',
      'Market Trend Analytics',
      'Property Investment Analysis',
      'ROI & Cash Flow Calculations',
      'Neighborhood Analysis & Scoring',
      'Valuation Report Generation',
      'API Integration with MLS Systems'
    ],
    pricing: { setup: 45000, monthly: 2070 },
    color: 'from-purple-500 to-pink-600'
  },
  {
    id: 'short-term-rental-management',
    title: 'Short-Term Rental Management',
    subtitle: 'Airbnb & vacation rental platform',
    description: 'Complete short-term rental management with booking synchronization, guest communication, and revenue optimization.',
    icon: Key,
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Real Estate & Property',
    status: 'Available',
    businessTypes: ['#short-term-rentals', '#airbnb-hosts', '#vacation-rentals', '#property-hosting', '#rental-income'],
    features: [
      'Multi-Platform Booking Synchronization',
      'Dynamic Pricing & Revenue Optimization',
      'Guest Communication & Automation',
      'Cleaning & Maintenance Scheduling',
      'Check-in/Check-out Management',
      'Review Management & Responses',
      'Financial Reporting & Tax Documentation',
      'Channel Manager Integration'
    ],
    pricing: { setup: 36000, monthly: 1656 },
    color: 'from-orange-500 to-red-600'
  },
  {
    id: 'commercial-real-estate-platform',
    title: 'Commercial Real Estate Platform',
    subtitle: 'Enterprise property management',
    description: 'Comprehensive commercial real estate management with lease administration, tenant relations, and portfolio analytics.',
    icon: Building,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Real Estate & Property',
    status: 'Available',
    businessTypes: ['#commercial-real-estate', '#office-buildings', '#retail-properties', '#industrial-real-estate', '#property-investment'],
    features: [
      'Commercial Lease Administration',
      'Tenant Relationship Management',
      'Space Planning & Allocation',
      'CAM (Common Area Maintenance) Billing',
      'Portfolio Performance Analytics',
      'Capital Expenditure Tracking',
      'Property Marketing & Leasing',
      'Financial Reporting & Compliance'
    ],
    pricing: { setup: 55000, monthly: 2530 },
    color: 'from-cyan-500 to-blue-600'
  },
  {
    id: 'construction-project-tracker',
    title: 'Construction Project Tracker',
    subtitle: 'Real estate development management',
    description: 'Specialized project management for real estate development with construction tracking, budget management, and timeline coordination.',
    icon: FileText,
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Real Estate & Property',
    status: 'Available',
    businessTypes: ['#construction-management', '#real-estate-development', '#project-management', '#building-contractors', '#property-development'],
    features: [
      'Construction Timeline Management',
      'Budget Tracking & Cost Control',
      'Contractor & Vendor Management',
      'Permit & Compliance Tracking',
      'Progress Photos & Documentation',
      'Quality Control & Inspections',
      'Change Order Management',
      'Financial Reporting & Cash Flow'
    ],
    pricing: { setup: 48000, monthly: 2208 },
    color: 'from-yellow-500 to-orange-600'
  }
];
